import LandCarousel from "./LandCarousel";
import LandImg from "./LandImg";
import LandImage from "./landscaping.jpg"; // Adjust path as needed
import "./Landscaping.css";

export default function Landscaping() {
  return (
    <div
      className="parallax-container"
      style={{ backgroundImage: `url(${LandImage})` }}
    >
      <div className="content">
        <LandImg />
        <LandCarousel />
      </div>
    </div>
  );
}
